import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rail-services__list" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<li class=\"rail-services__list-item rail-services__list-item--ice\"></li><li class=\"rail-services__list-item rail-services__list-item--knife\"></li><li class=\"rail-services__list-item rail-services__list-item--news\"></li><li class=\"rail-services__list-item rail-services__list-item--wash\"></li><li class=\"rail-services__list-item rail-services__list-item--internet\"></li><li class=\"rail-services__list-item rail-services__list-item--bed\"></li>", 6)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    _hoisted_2
  ]))
}